import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import moment from 'moment/moment.js';
import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as bootstrap from 'bootstrap';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import {
  onGoBack,
  storeLastVisitedRoute
} from '../../common/globals';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';
import withSetsSearch from '../../common/withSetsSearch';
import withOfficeSetsFilter from '../../common/withOfficeSetsFilter';
import Header from '../../components/Header';
import {
  initAPIController,
  getShipments,
  searchToObject
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import ShipmentsProducts from '../../components/ManageCase/ShipmentsProducts.js';
import ShipmentsCaseDates from '../../components/ManageCase/ShipmentsCaseDates.js';
import ShipmentsShipDates from '../../components/ManageCase/ShipmentsShipDates.js';
import ShipmentsShipTo from '../../components/ManageCase/ShipmentsShipTo.js';
import TruckOutlineIcon from '../../assets/images/Truck-new.png';
import SortAscIcon from '../../assets/images/asc.png';
import SortDescIcon from '../../assets/images/desc.png';
import ArrowExpand from '../../assets/images/arrow-expand-vertical.png';
import ArrowCollapse from '../../assets/images/arrow-collapse-vertical.png';
// import ReportLogo from '../../assets/images/white_report_logo.png';
import ReportDarkLogo from '../../assets/images/dark_report_logo.png';
import Printer from '../../assets/images/printer-outline-custom.png';
import OpenSans from '../../assets/fonts/OpenSans.ttf';
import OpenSansBold from '../../assets/fonts/OpenSans-Bold.ttf';
import withThemeColor from '../../common/withThemeColor.js';

class Shipments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedAt: '',
      accounts: [],
      shipments: [],
      isCaseType: false,
      selectedShipTo: [],
      selectedShipDate: [],
      selectedCaseDate: [],
      selectedProduct: [],
      isShipTo: false,
      isShipDate: false,
      isCaseDate: false,
      isProduct: false,
      isDePuy: true,
      noRecords: true,
      sortDirection: -1,
      rowsCollapsed: false
    };
    this.apiController = null;
  }

  _onSort = () => {
    this.setState({ sortDirection: this.state.sortDirection * -1 }, this._sortShipments);
  }

  _sortShipments = () => {
    const { shipments, sortDirection, isDePuy } = this.state;
    const sortedShipments = {};
    if (isDePuy) {
      Object.keys(shipments).forEach((account) => {
        sortedShipments[account] = shipments[account].sort((itemA, itemB) => {
          if (itemA.OrderDate > itemB.OrderDate) {
            return sortDirection;
          }
          if (itemA.OrderDate < itemB.OrderDate) {
            return sortDirection * -1;
          }
          if (itemA.OrderDate === itemB.OrderDate) {
            if (itemA.OrderNo > itemB.OrderNo) {
              return -1;
            }
            if (itemA.OrderNo < itemB.OrderNo) {
              return 1;
            }
            if (itemA.OrderNo === itemB.OrderNo) {
              return 0;
            }
          }
        });
      });
    } else {
      Object.keys(shipments).forEach((account) => {
        sortedShipments[account] = shipments[account].sort((itemA, itemB) => {
          if (itemA.ShipDate > itemB.ShipDate) {
            return sortDirection;
          }
          if (itemA.ShipDate < itemB.ShipDate) {
            return sortDirection * -1;
          }
          if (itemA.OrderDate === itemB.OrderDate) {
            return 0;
          }
        });
      });
    }
    this.setState({ shipments: sortedShipments });
  }

  _onToggleCollapse = () => {
    const { rowsCollapsed } = this.state;
    this.setState({ rowsCollapsed: !rowsCollapsed }, () => {
      const collapseElementList = document.querySelectorAll('.collapse');
      collapseElementList.forEach((collapseEl) => {
        if (this.state.rowsCollapsed) {
          const collapseInstance = new bootstrap.Collapse(`#${collapseEl.id}`, { toggle: false });
          collapseInstance.hide();
        } else {
          const collapseInstance = new bootstrap.Collapse(`#${collapseEl.id}`, { toggle: false });
          collapseInstance.show();
        }
      });
    });
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onShipToClick = () => {
    try {
      this.setState({ isShipTo: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseDateClick = () => {
    try {
      this.setState({ isCaseDate: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductClick = () => {
    try {
      this.setState({ isProduct: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShipDateClick = () => {
    try {
      this.setState({ isShipDate: true });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedShipTo = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedShipTo: [...prevState.selectedShipTo, selection],
        isShipTo: false
      }), () => {
        this._onShipmentsSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedShipDate = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedShipDate: [...prevState.selectedShipDate, selection],
        isShipDate: false
      }), () => {
        this._onShipmentsSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseDate = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedCaseDate: [...prevState.selectedCaseDate, selection],
        isCaseDate: false
      }), () => {
        this._onShipmentsSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedProduct = (selection) => {
    try {
      this.setState((prevState) => ({
        selectedProduct: [...prevState.selectedProduct, selection],
        isProduct: false
      }), () => {
        this._onShipmentsSearch();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (trackingNo, productNo = null) => {
    this._onGoBack();
    storeLastVisitedRoute(`shipments?shipFromLoc=${this.state.isDePuy ? 'DEPUY' : 'OFFICE'}`);
    browserHistory.push(`/inventory/shipments/${trackingNo}${productNo ? `?productNo=${productNo}` : ''}`);
  }

  _onGoBackSetInfo = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShipmentsBack = () => {
    try {
      this.setState({
        isShipTo: false,
        isShipDate: false,
        isCaseDate: false,
        isProduct: false,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShipmentsSearch = async () => {
    try {
      const {
        online, setLoader, notify
      } = this.props;
      const searchData = {};
      if (this.state.selectedShipTo.length > 0) {
        searchData.shipTo = this.state.selectedShipTo;
      }
      if (this.state.selectedShipDate.length) {
        searchData.shipDate = this.state.selectedShipDate.map((shipDate) => moment(shipDate).format('MM-DD-YY'));
      }
      if (this.state.selectedCaseDate.length) {
        searchData.caseDate = this.state.selectedCaseDate.map((shipDate) => moment(shipDate).format('MM-DD-YY'));
      }
      if (this.state.selectedProduct.length) {
        searchData.productNo = this.state.selectedProduct;
      }
      if (online) {
        setLoader(true);
        if (this.apiController) {
          this.apiController.abort();
        }
        this.apiController = initAPIController();
        const res = await getShipments(searchData, this.state.isDePuy ? 'DEPUY' : 'OFFICE');
        if (res.status) {
          if (res.data.length === 0 && Object.keys(searchData).length === 0) {
            this.setState({
              noRecords: true,
              updatedAt: moment().format('MM/DD/YY hh:mm A')
            });
            setLoader(false);
            return;
          }
          const accountSet = new Set();
          const trackingsSet = new Set();
          const servicesSet = new Set();
          const caseDateSet = new Set();
          const orderNoSet = new Set();
          let mostRecentUpdate = new Date(0);
          res.data.forEach((item) => {
            if (new Date(item.DateUpdated) > mostRecentUpdate) {
              mostRecentUpdate = item.DateUpdated;
            }
            accountSet.add(item.ShipToLoc);
            trackingsSet.add(item.TrackingNo);
            servicesSet.add(item.Service);
            caseDateSet.add(item.CaseDate);
            orderNoSet.add(item.OrderNo);
          });
          const sortedAccounts = Array.from(accountSet).sort();

          if (this.state.isDePuy) {
            const shipmentsResult = this._structureDePuyShipments(
              sortedAccounts,
              orderNoSet,
              res
            );
            this.setState({
              accounts: sortedAccounts,
              shipments: shipmentsResult,
              noRecords: false,
              updatedAt: moment(mostRecentUpdate).format('MM/DD/YY hh:mm A'),
            }, this._sortShipments);
          } else {
            const shipmentsResult = this._structureOfficeShipments(
              sortedAccounts,
              servicesSet,
              caseDateSet,
              res
            );
            this.setState({
              accounts: sortedAccounts,
              shipments: shipmentsResult,
              noRecords: false,
              updatedAt: moment(mostRecentUpdate).format('MM/DD/YY hh:mm A'),
            }, this._sortShipments);
          }
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _structureOfficeShipments = (sortedAccounts, servicesSet, caseDateSet, res) => {
    const shipmentsResult = {};
    sortedAccounts.forEach((account) => {
      // shipmentsResult[account] = res.data
      //   .filter((item) => item.ShipToLoc === account);
      shipmentsResult[account] = [];
      servicesSet.forEach((service) => {
        const shipmentsWithCrtTracking = res.data
          .filter((item) => item.ShipToLoc === account && item.Service === service);
        if (shipmentsWithCrtTracking.length) {
          const objToAdd = {
            ShipDate: null,
            DueDate: null,
            Service: null,
            caseDates: {}
          };
          objToAdd.ShipDate = shipmentsWithCrtTracking[0].ShipDate;
          objToAdd.DueDate = shipmentsWithCrtTracking[0].DueDate;
          objToAdd.Service = shipmentsWithCrtTracking[0].Service;
          objToAdd.TrackingNo = shipmentsWithCrtTracking[0].TrackingNo;
          caseDateSet.forEach((caseDate) => {
            const shipmentsWithCrtCaseDate = shipmentsWithCrtTracking
              .filter((item) => item.CaseDate === caseDate);
            if (!shipmentsWithCrtCaseDate.length) return;
            objToAdd.caseDates[caseDate] = shipmentsWithCrtCaseDate;
          });
          shipmentsResult[account].push(objToAdd);
        }
      });
    });
    return shipmentsResult;
  }

  _structureDePuyShipments = (sortedAccounts, orderNoSet, res) => {
    const shipmentsResult = {};
    sortedAccounts.forEach((account) => {
      shipmentsResult[account] = [];
      orderNoSet.forEach((orderNo) => {
        const shipmentsWithCrtNumber = res.data
          .filter((item) => item.ShipToLoc === account && item.OrderNo === orderNo);
        shipmentsWithCrtNumber.sort((shipA, shipB) => {
          if (!shipA.ShipDate) {
            return 1;
          }
          if (!shipB.ShipDate) {
            return -1;
          }
          if (moment(shipA.ShipDate) > moment(shipB.ShipDate)) {
            return -1;
          }
          if (moment(shipA.ShipDate) < moment(shipB.ShipDate)) {
            return 1;
          }
          return 0;
        });
        if (shipmentsWithCrtNumber.length) {
          const objToAdd = {
            OrderDate: shipmentsWithCrtNumber[0].OrderDate,
            OrderNo: shipmentsWithCrtNumber[0].OrderNo,
            shipments: shipmentsWithCrtNumber
          };
          shipmentsResult[account].push(objToAdd);
        }
      });
    });
    return shipmentsResult;
  }

  _onFromLocationChange = () => {
    this.setState({
      isDePuy: !this.state.isDePuy,
      selectedShipTo: [],
      selectedShipDate: [],
      selectedCaseDate: [],
      selectedProduct: [],
      accounts: [],
      shipments: [],
      sortDirection: -1,
      rowsCollapsed: false
    }, () => {
      browserHistory.push(`/inventory/shipments?shipFromLoc=${this.state.isDePuy ? 'DEPUY' : 'OFFICE'}`);
      this._onShipmentsSearch();
    });
  }

  _onPrint = () => {
    try {
      const { themeColor } = this.props;
      const {
        updatedAt,
        accounts,
        shipments
      } = this.state;

      const documentTitle = 'J&JMedTech.pdf';
      const doc = new JsPDF({
        unit: 'cm',
      });

      const docuemntConstants = {
        headerHeight: 3,
      };

      doc.setProperties({
        title: documentTitle,
      });

      doc.addFont(OpenSans, 'OpenSans', 'normal');
      doc.addFont(OpenSansBold, 'OpenSans', 'bold');
      doc.setFont('OpenSans');
      const addHeader = (document) => {
        document.addImage((themeColor === 'light' ? ReportDarkLogo : ReportDarkLogo), 'PNG', 2, 1.5, 3.5, 0.7);
        document.setFontSize(9);
        document.text(`pdf generated: ${moment().format('YYYY-MM-DD HH:mm:ss')}`, 19, 1.85, {
          align: 'right',
        });
        document.setDrawColor('#808080');
        document.setLineWidth(0.05);
        document.rect(0.5, 0.5, 20, 28.5);
      };

      autoTable(doc, {
        margin: {
          top: docuemntConstants.headerHeight, left: 2, right: 2, bottom: 2
        },
        styles: {
          font: 'OpenSans',
          fontSize: 10,
          lineWidth: 0,
          cellPadding: 0.1,
        },
        theme: 'plain',
        showHead: 'everyPage',
        didDrawPage: () => {
          addHeader(doc);

          doc.setFontSize(14);
          doc.setFont('OpenSans', '700');
          doc.text('Shipped From: J&J MedTech', 2, 4);
          doc.setFontSize(11);
          doc.setFont('OpenSans', 'normal');
          doc.text(`Updated: ${updatedAt}`, 2, 4.5);
        }
      });

      let { finalY } = doc.lastAutoTable;
      if (finalY + 3 > doc.internal.pageSize.height) {
        doc.addPage();
        finalY = docuemntConstants.headerHeight;
      }

      accounts.forEach((item) => {
        // final Y + 2 for the title + 1 for each row and one additional row for the total
        autoTable(doc, {
          margin: {
            top: 2,
            left: 1.8,
            right: 2,
            bottom: 0
          },
          startY: finalY + 2,
          theme: 'plain',
          styles: {
            font: 'OpenSans',
            fontSize: 14,
            fontStyle: 'bold'
          },
          body: [
            {
              item
            }
          ],
          didParseCell: (data) => {
            // if (
            //   data.row.section === 'head' &&
            //   ['name', 'city'].includes(data.column.dataKey)
            // ) {
            //   data.cell.styles.lineColor = 'black'
            //   data.cell.styles.lineWidth = {
            //     bottom: 1,
            //   }
            // }
            if (data.row.section === 'body') {
              data.cell.styles.lineColor = '#cdcdcd'; // cell border color
              data.cell.styles.lineWidth = {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0.05, // only bottom border will be painted
              };
            }
          },
        });

        shipments[item].forEach((accountShipment) => {
          let finalYShip = doc.lastAutoTable.finalY;

          const bodyData = [];
          bodyData.push([
            {
              content: `Order Date: ${accountShipment.OrderDate
                ? moment(accountShipment.OrderDate).format('MM/DD/YY') : null}`,
              styles: {
                halign: 'left', fontStyle: 'bold', minCellWidth: 3,
              }
            }, {
              content: `Order # ${accountShipment.OrderNo}`,
              styles: {
                halign: 'left', fontStyle: 'bold', minCellWidth: 3,
              }
            },
            {
              content: '',
              styles: {
                halign: 'left', fontStyle: 'bold', minCellWidth: 4,
              }
            },
          ]);

          autoTable(doc, {
            margin: {
              top: 2.5,
              left: 1.8,
              right: 2,
              bottom: 2.5,
            },
            startY: finalYShip + 0.5,
            theme: 'plain',
            tableLineWidth: 0,
            cellWidth: 'wrap',
            styles: {
              font: 'OpenSans',
              fontSize: 10,
            },
            didDrawPage: () => {
              addHeader(doc);
              // finalYShip = HookData.settings.startY + 1;
              finalYShip = doc.lastAutoTable.finalY + 1;
            },
            body: bodyData,
          });

          const bodyNested = [];
          accountShipment.shipments.forEach((shipmentItem) => {
            bodyNested.push({
              product: shipmentItem.ProductNo,
              productDes: shipmentItem.ProductDescription,
              qty: shipmentItem.Qty,
              shipDate: shipmentItem.ShipDate ? moment(shipmentItem.ShipDate).format('MM/DD/YY') : null,
            });
          });

          let finalYShipment = doc.lastAutoTable.finalY;

          doc.autoTable({
            margin: {
              top: 2.5,
              left: 1.8,
              right: 2,
              bottom: 2.5,
            },
            startY: finalYShipment + 0.5,
            styles: {
              font: 'OpenSans',
            },
            theme: 'plain',
            headStyles: {
              fontSize: 9,
            },
            columnStyles: {
              product: {
                minCellWidth: 2,
              },
              productDes: {
                minCellWidth: 6,
              },
              qty: {
                halign: 'center',
                minCellWidth: 2,
              },
              shipDate: {
                minCellWidth: 2,
              },
            },
            didDrawPage: () => {
              addHeader(doc);
              finalYShipment = doc.lastAutoTable.finalY + 1;
            },
            didParseCell: (data) => {
              if (
                data.row.section === 'head' && ['qty'].includes(data.column.dataKey)
              ) {
                data.cell.styles.halign = 'center';
                data.cell.styles.minCellWidth = 2;
              }

              if (
                data.row.section === 'head' && ['product'].includes(data.column.dataKey)
              ) {
                data.cell.styles.minCellWidth = 2;
              }

              if (
                data.row.section === 'head' && ['productDes'].includes(data.column.dataKey)
              ) {
                data.cell.styles.minCellWidth = 6;
              }

              if (
                data.row.section === 'head' && ['shipDate'].includes(data.column.dataKey)
              ) {
                data.cell.styles.minCellWidth = 2;
              }
            },
            columns: [
              { dataKey: 'product', header: 'Product' },
              { dataKey: 'productDes', header: '' },
              { dataKey: 'qty', header: 'Qty', halign: 'center' },
              { dataKey: 'shipDate', header: 'Ship Date' },
            ],
            body: bodyNested,
          });
        });

        finalY = doc.lastAutoTable.finalY - 1;
      });

      if (window.mobileCheck()) {
        doc.save(documentTitle);
      } else {
        doc.output('dataurlnewwindow', documentTitle);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    const { online, notify, location } = this.props;
    try {
      if (location.search.includes('OFFICE')) {
        const queryParams = searchToObject(location.search);
        this.setState({
          isDePuy: false,
          selectedShipTo: Object.hasOwn(queryParams, 'shipTo') ? [queryParams.shipTo] : []
        }, async () => {
          if (online) await this._onShipmentsSearch();
          else {
            notify({
              type: 'error',
              message: 'You must have an internet connection. Please check your connection and try again.',
              time: 5
            });
          }
        });
      } else {
        const queryParams = searchToObject(location.search);
        this.setState({
          selectedShipTo: Object.hasOwn(queryParams, 'shipTo') ? [queryParams.shipTo] : []
        }, async () => {
          if (online) await this._onShipmentsSearch();
          else {
            notify({
              type: 'error',
              message: 'You must have an internet connection. Please check your connection and try again.',
              time: 5
            });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render = () => {
    const {
      online, notify, setLoader
    } = this.props;
    const {
      isShipTo, isShipDate, isCaseDate, isProduct, updatedAt, isDePuy, selectedShipTo, accounts,
      shipments, selectedShipDate, selectedCaseDate, noRecords, selectedProduct,
      sortDirection, rowsCollapsed
    } = this.state;
    return (
      <section className="list-section">
        {isShipDate || isShipTo || isProduct || isCaseDate ? (
          <Header
            title={isShipTo ? 'Ship To' : isShipDate ? 'Ship Date' : isCaseDate ? 'Case Date' : isProduct ? 'Product' : 'Shipments'}
            goBack={(isShipTo || isShipDate || isCaseDate || isProduct)
              ? this._onShipmentsBack : this._onGoBackSetInfo}
          />
        ) : (
          <Header
            title="Shipments"
            goBack={(isShipTo || isShipDate || isCaseDate || isProduct)
              ? this._onShipmentsBack : this._onGoBackSetInfo}
            // actionButton={{
            //   onClick: () => this._onFromLocationChange(),
            //   title: isDePuy ? 'Office' : 'DePuy'
            // }}
            customRightSide={(
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                width: '100%',
                justifyContent: 'flex-end'
              }}
              >
                {
                  isDePuy && (
                    <Link
                      className="btn-link sub-header-text cursor-pointer"
                      style={{ whiteSpace: 'nowrap' }}
                      onClick={() => this._onPrint()}
                    >
                      <img style={{ width: '20px' }} src={Printer} alt="print" />
                    </Link>
                  )
                }

                <Link
                  className="btn-link sub-header-text cursor-pointer"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this._onFromLocationChange()}
                >
                  {isDePuy ? 'Office' : 'J&J MedTech'}
                </Link>
              </div>
            )}
          />
        )}

        {
          !isShipTo
            ? !isShipDate
              ? !isCaseDate
                ? !isProduct ? (
                  <div className="container backorders-np">
                    <section className="sets-section">
                      <div
                        className="bg-theme"
                        style={{
                          padding: '8px 8px 16px',
                          position: 'sticky',
                          top: 45,
                          zIndex: 1000,
                          backgroundColor: '#212121'
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div className="row">
                            <div className="col-9" style={{ display: 'flex', flexDirection: 'column' }}>
                              <span>Shipped From: {isDePuy ? 'J&J MedTech' : 'Office'}</span>
                              <span style={{ marginBottom: 8 }}>Updated: {updatedAt}</span>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                                  style={{ padding: '2px 12px', fontWeight: 'normal' }}
                                  onClick={this._onShipToClick}
                                >Ship To
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                                  style={{ padding: '2px 12px', fontWeight: 'normal' }}
                                  onClick={this._onShipDateClick}
                                > Ship Date
                                </button>
                                {isDePuy ? (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                                    style={{ padding: '2px 20px', fontWeight: 'normal' }}
                                    onClick={this._onProductClick}
                                  >
                                    Product
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                                    style={{ padding: '2px 20px', fontWeight: 'normal' }}
                                    onClick={this._onCaseDateClick}
                                  >
                                    Case Date
                                  </button>
                                )}
                              </div>
                            </div>
                            <div
                              className="col-3"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                gap: '10px'
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                                onClick={() => this._onSort()}
                              >
                                {sortDirection > 0 ? (
                                  <img src={SortDescIcon} alt="sort-asc" style={{ maxWidth: '25px', aspectRatio: '1' }} />
                                ) : (
                                  <img src={SortAscIcon} alt="sort-asc" style={{ maxWidth: '25px', aspectRatio: '1' }} />
                                )}
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                                onClick={() => this._onToggleCollapse()}
                              >
                                {rowsCollapsed ? (
                                  <img src={ArrowExpand} alt="sort-asc" style={{ maxWidth: '25px', aspectRatio: '1' }} />
                                ) : (
                                  <img src={ArrowCollapse} alt="sort-asc" style={{ maxWidth: '25px', aspectRatio: '1' }} />
                                )}

                              </button>
                            </div>
                          </div>

                          <div className="button-scrollarea">
                            {
                              selectedShipTo.map(
                                (account, i) => (
                                  <div
                                    key={`account-${i + 1}`}
                                    className="filterTagShipments"
                                  >
                                    <p style={{
                                      width: '90%',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      marginBottom: 0
                                    }}
                                    >
                                      {account}
                                    </p>
                                    <div
                                      onClick={() => {
                                        const tempShipTo = selectedShipTo;
                                        tempShipTo.splice(i, 1);
                                        this.setState({
                                          selectedShipTo: tempShipTo
                                        }, this._onShipmentsSearch);
                                      }}
                                      style={{
                                        marginLeft: 16,
                                        cursor: 'pointer'
                                      }}
                                    >
                                      x
                                    </div>
                                  </div>
                                )
                              )
                            }
                            {
                              selectedShipDate ? selectedShipDate.map(
                                (shipDate, i) => (
                                  <div
                                    key={i}
                                    className="filterTagShipments"
                                  >
                                    <p style={{
                                      width: '90%',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      marginBottom: 0
                                    }}
                                    >
                                      {moment(shipDate).format('MM/DD/YY')}
                                    </p>
                                    <div
                                      onClick={() => {
                                        const tempSelectedShipDate = selectedShipDate;
                                        tempSelectedShipDate.splice(i, 1);
                                        this.setState({
                                          selectedShipDate: tempSelectedShipDate
                                        }, this._onShipmentsSearch);
                                      }}
                                      style={{ marginLeft: 16, cursor: 'pointer' }}
                                    >
                                      x
                                    </div>
                                  </div>
                                )
                              ) : null
                            }

                            {
                              selectedCaseDate ? selectedCaseDate.map(
                                (caseDate, i) => (
                                  <div
                                    key={i}
                                    className="filterTagShipments"
                                  >
                                    <p style={{
                                      width: '90%',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      marginBottom: 0
                                    }}
                                    >
                                      {moment(caseDate).format('MM/DD/YY')}
                                    </p>
                                    <div
                                      onClick={() => {
                                        const tempSelectedCaseDate = selectedCaseDate;
                                        tempSelectedCaseDate.splice(i, 1);
                                        this.setState({
                                          selectedCaseDate: tempSelectedCaseDate
                                        }, this._onShipmentsSearch);
                                      }}
                                      style={{ marginLeft: 16, cursor: 'pointer' }}
                                    >
                                      x
                                    </div>
                                  </div>
                                )
                              ) : null
                            }

                            {
                              selectedProduct ? selectedProduct.map(
                                (product, i) => (
                                  <div
                                    key={i}
                                    className="filterTagShipments"
                                  >
                                    <p style={{
                                      width: '90%',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      marginBottom: 0
                                    }}
                                    >
                                      {product}
                                    </p>
                                    <div
                                      onClick={() => {
                                        const tempSelectedProduct = selectedProduct;
                                        tempSelectedProduct.splice(i, 1);
                                        this.setState({
                                          selectedProduct: tempSelectedProduct
                                        }, this._onShipmentsSearch);
                                      }}
                                      style={{ marginLeft: 16, cursor: 'pointer' }}
                                    >
                                      x
                                    </div>
                                  </div>
                                )
                              ) : null
                            }
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          {accounts.length > 0
                            ? accounts.map((item, index) => (
                              <div key={index}>
                                <div
                                  style={{
                                    top: selectedShipTo.length > 0
                                      || selectedShipDate.length
                                      || selectedCaseDate.length ? 178 : 143,
                                    position: 'sticky',
                                    zIndex: 10
                                  }}
                                >
                                  <h4
                                    className="bg-shipment-label"
                                    style={{
                                      backgroundColor: '#0E120F',
                                      fontSize: 15,
                                      width: '100%',
                                      padding: '8px',
                                      marginBottom: 0,
                                      zIndex: 999,
                                    }}
                                  >
                                    {item}
                                  </h4>
                                  <div
                                    className={`row ${isDePuy ? 'bg-theme' : 'bg-card-filed'}`}
                                    style={{
                                      color: '#A6A6A6',
                                      margin: '0',
                                      padding: '4px 0',
                                      backgroundColor: '#212121'
                                    }}
                                  >
                                    {isDePuy ? (
                                      <div className="col-10">
                                        <div className="row">
                                          <div className="col-4">Order Date</div>
                                          <div className="col-4">Order #</div>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="col-3 col-sm-2">Ship Date</div>
                                        <div className="col-3 col-sm-2">Due Date</div>
                                        <div className="col-3 col-sm-2">Service</div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {isDePuy ? shipments[item].length > 0 ? shipments[item]
                                  .map((accountShipment, i) => (
                                    <div key={`${index}-${i + 1}`}>
                                      <div
                                        className="row bg-theme"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${index}-${i + 1}`}
                                        style={{
                                          backgroundColor: '#212121',
                                          margin: '0',
                                          padding: '5px 0',
                                          top: selectedShipTo.length > 0
                                            || selectedShipDate.length
                                            || selectedCaseDate.length ? 238 : 203,
                                          position: 'sticky',
                                        }}
                                        aria-expanded="false"
                                      >
                                        <div className="col-10">
                                          <div className="row">
                                            <div className="col-4">
                                              {accountShipment.OrderDate ? moment(accountShipment.OrderDate).format('MM/DD/YY') : null}
                                            </div>
                                            <div className="col-4">
                                              {accountShipment.OrderNo}
                                            </div>
                                            <div className="col-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                              <div
                                                className="btn-collapse"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}-${i + 1}`}
                                                aria-expanded="false"
                                              >
                                                <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="collapse show" id={`collapse${index}-${i + 1}`}>
                                        <div
                                          className="bg-cell"
                                          style={{
                                            width: '100%',
                                            marginBottom: 2,
                                            backgroundColor: '#424242',
                                            padding: '2px 10px'
                                          }}
                                        >
                                          <div className="row" style={{ color: '#A6A6A6' }}>
                                            <div className="col-10">
                                              <div className="row">
                                                <div className="col-4">Product</div>
                                                <div className="col-4">Qty</div>
                                                <div className="col-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>Ship Date</div>
                                              </div>
                                            </div>
                                          </div>
                                          {accountShipment.shipments
                                            .map((shipmentItem) => (
                                              <div
                                                key={shipmentItem.ID}
                                                className="row"
                                                style={{ marginBottom: '10px' }}
                                              >
                                                <div className="col-10">
                                                  <div className="row">
                                                    <div className="col-4">
                                                      {shipmentItem.ProductNo}
                                                    </div>
                                                    <div className="col-4">
                                                      {shipmentItem.Qty}
                                                    </div>
                                                    <div className="col-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                      {shipmentItem.ShipDate
                                                        ? moment(shipmentItem.ShipDate).format('MM/DD/YY')
                                                        : null}
                                                    </div>
                                                  </div>
                                                  {shipmentItem.ProductDescription}
                                                </div>
                                                <div className="col-2" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                  {shipmentItem.TrackingNo ? (
                                                    <div
                                                      onClick={
                                                        () => this
                                                          ._onRedirect(shipmentItem.TrackingNo)
                                                      }
                                                      style={{ cursor: 'pointer' }}
                                                    >
                                                      <img
                                                        style={{ minWidth: '25px', width: '25px', objectFit: 'contain' }}
                                                        src={TruckOutlineIcon}
                                                        alt="shipments"
                                                      />
                                                    </div>
                                                  ) : null}
                                                </div>
                                              </div>
                                            ))}
                                        </div>
                                      </div>
                                    </div>
                                  )) : null
                                  : shipments[item].length > 0 ? shipments[item]
                                    .map((accountShipment, i) => (
                                      <div key={`${index}-${i + 1}`}>
                                        <div
                                          className="row bg-card-filed"
                                          data-bs-toggle="collapse"
                                          data-bs-target={`#collapse${index}-${i + 1}`}
                                          style={{
                                            backgroundColor: '#212121',
                                            margin: '0',
                                            padding: '5px 0',
                                            top: selectedShipTo.length > 0
                                              || selectedShipDate.length
                                              || selectedCaseDate.length ? 240 : 205,
                                            position: 'sticky',
                                          }}
                                          aria-expanded="false"
                                        >
                                          <div className="col-3 col-sm-2">
                                            {accountShipment.ShipDate ? moment(accountShipment.ShipDate).format('MM/DD/YY') : null}
                                          </div>
                                          <div className="col-3 col-sm-2">
                                            {accountShipment.DueDate ? moment(accountShipment.DueDate).format('MM/DD/YY') : null}
                                          </div>
                                          <div className="col-4 col-sm-6">
                                            <span
                                              style={{
                                                display: 'inline-block',
                                                width: '100%',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                              }}
                                              title={accountShipment.Service}
                                            >
                                              {accountShipment.Service}
                                            </span>
                                          </div>
                                          <div className="col-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <div
                                              className="btn-collapse"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#collapse${index}-${i + 1}`}
                                              aria-expanded="false"
                                            >
                                              <i className="fas fa-chevron-down" style={{ color: '#eda340' }} />
                                            </div>
                                          </div>
                                          <div className="col-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <div
                                              onClick={
                                                () => this
                                                  ._onRedirect(accountShipment.TrackingNo)
                                              }
                                              style={{ cursor: 'pointer' }}
                                            >
                                              <img style={{ minWidth: '25px', width: '25px' }} src={TruckOutlineIcon} alt="shipments" />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="collapse show" id={`collapse${index}-${i + 1}`}>
                                          <div
                                            className="bg-theme"
                                            style={{
                                              width: '100%',
                                              marginBottom: 2,
                                              backgroundColor: '#424242',
                                              padding: '2px 10px'
                                            }}
                                          >
                                            {Object.keys(accountShipment.caseDates)
                                              .map((caseDate) => (
                                                <div key={caseDate} style={{ marginBottom: '10px' }}>
                                                  <span style={{ textDecoration: 'underline', color: '#A6A6A6' }}>
                                                    Case Date:
                                                  </span>
                                                  {caseDate !== 'null'
                                                    ? ` ${moment(caseDate).format('MM/DD/YY')}` : ' N/A'}
                                                  {accountShipment.caseDates[caseDate]
                                                    .map((shippmentItem) => (
                                                      <div key={shippmentItem.ID}>
                                                        {shippmentItem.ItemNo ? `${shippmentItem.ItemNo}. ` : (<><span style={{ opacity: 0 }}>0</span>. </>)}
                                                        {shippmentItem.SetName}
                                                        {shippmentItem.SetNo ? ` #${shippmentItem.SetNo}` : null}
                                                      </div>
                                                    ))}
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                      </div>
                                    )) : null}
                              </div>
                            ))
                            : noRecords
                              ? <p className="text-center">No Shipments are currently recorded for your team.</p>
                              : <p className="text-center">No sets match to your filters</p>}
                        </div>
                      </div>
                    </section>
                  </div>
                )
                  : (
                    <ShipmentsProducts
                      notify={notify}
                      setLoader={setLoader}
                      online={online}
                      selectedShipTo={selectedShipTo}
                      selectedShipDate={selectedShipDate}
                      onSelectedProduct={this._onSelectedProduct}
                      onBackFromFilters={this._onShipmentsBack}
                      selectedProduct={selectedProduct}
                      isDePuy={isDePuy}
                    />
                  )
                : (
                  <ShipmentsCaseDates
                    notify={notify}
                    setLoader={setLoader}
                    online={online}
                    selectedShipTo={selectedShipTo}
                    selectedShipDate={selectedShipDate}
                    onSelectedCaseDate={this._onSelectedCaseDate}
                    onBackFromFilters={this._onShipmentsBack}
                    selectedCaseDate={selectedCaseDate}
                  />
                )
              : (
                <ShipmentsShipDates
                  notify={notify}
                  setLoader={setLoader}
                  online={online}
                  selectedProduct={selectedProduct}
                  selectedShipTo={selectedShipTo}
                  selectedCaseDate={selectedCaseDate}
                  onSelectedShipDate={this._onSelectedShipDate}
                  onBackFromFilters={this._onShipmentsBack}
                  selectedShipDate={selectedShipDate}
                  isDePuy={isDePuy}
                />
              )
            : (
              <ShipmentsShipTo
                notify={notify}
                setLoader={setLoader}
                online={online}
                selectedProduct={selectedProduct}
                selectedShipDate={selectedShipDate}
                selectedCaseDate={selectedCaseDate}
                onSelectedShipTo={this._onSelectedShipTo}
                onBackFromFilters={this._onShipmentsBack}
                selectedShipTo={selectedShipTo}
                isDePuy={isDePuy}
              />
            )
        }
      </section>
    );
  }
}

export default withOfficeSetsFilter(
  withSetsSearch(
    withOnline(
      withGoBack(
        withNotify(
          withLoader(
            withThemeColor(
              Shipments
            )
          )
        )
      )
    )
  )
);
